<template>
  <div class="px-2 xl:py-3 md:px-0 md:py-0">
    <div
      class="flex items-center justify-between h-9 md:h-16 pl-4 pr-2 gap-x-1"
      :class="background(item)"
    >
      <div class="flex flex-col justify-center items-start w-1/5">
        <div
          class="font-nexa font-bold text-white text-lg md:text-2xl leading-5"
        >
          {{ item.name }}
        </div>
        <p class="text-agrogo-green-6 text-3xs md:text-xs space-x-px">
          <span
            v-for="(start, i) in starts"
            :key="i"
            class="icon-star2"
            :class="{
              'text-agrogo-green-6': start.isActive,
              'text-agrogo-green-5': !start.isActive,
            }"
          />
        </p>
      </div>
      <div
        class="flex justify-start items-center font-dinpro font-medium text-white text-2xl"
      >
        <span
          v-if="item.price !== '0'"
          class="icon-signo-pesos text-white text-xl leading-none pr-1.5"
        ></span>
        {{ item.price == "0" ? "Gratis" : item.price }}
      </div>
      <div class="flex items-center justify-end">
        <button
          @click.prevent="$emit('selected', item)"
          type="button"
          class="btn-primary flex items-center justify-center btn-width-step8 h-6 md:h-9 bg-agrogo-yellow-1 rounded-xl text-xs md:text-base text-agrogo-green-2 font-nexa font-bold"
          :disabled="(isBusy && item.id == idItem) || item.isDisable"
        >
          <div class="loader" v-if="isBusy && item.id == idItem" />
          <span v-else>Seleccionar</span>
        </button>
      </div>
    </div>
    <div
      class="w-full border border-t-0 border-agrogo-yellow-1 border-opacity-25 md:min-h-110"
    >
      <div class="flex px-4 py-4 h-auto w-auto">
        <div
          class="text-white text-sm md:text-base font-dinpro"
          :class="classStyle(item.id)"
          v-html="item.description_large"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    idItem: {
      type: Number,
      default: null,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      starts: [
        {
          isActive: false,
        },
        {
          isActive: false,
        },
        {
          isActive: false,
        },
        {
          isActive: false,
        },
        {
          isActive: false,
        },
      ],
    };
  },
  watch: {
    item() {
      const me = this;
      me.fillStart(me.item);
    },
  },
  methods: {
    fillStart(item) {
      const me = this;
      if (item.id == 4) {
        // Alto
        me.starts.forEach((el, index) => {
          if (index <= 2) {
            el.isActive = true;
          }
        });
      } else if (item.id == 5) {
        // Medio
        me.starts.forEach((el, index) => {
          if (index <= 1) {
            el.isActive = true;
          }
        });
      } else {
        // Básico
        me.starts.forEach((el, index) => {
          if (index <= 0) {
            el.isActive = true;
          }
        });
      }
      // Super 5 estrellas1
      // Plus 4 estrellas2
      // Alto 3 3
      // Medio 2 4
      // Basico 1 5
    },
    background(item) {
      let color;

      if (item.id == 4) {
        // Alto
        color = "backgroun3";
      } else if (item.id == 5) {
        // Medio
        color = "backgroun4";
      } else {
        // Básico
        color = "backgroun5";
      }

      return color;
    },
    classStyle(id) {
      let style = null;
      if (id == 6) {
        style = "style-info4";
      } else {
        style = "style-info3";
      }

      return style;
    },
  },
  mounted() {
    const me = this;
    me.fillStart(me.item);
  },
};
</script>

<style lang="css">
.backgroun3 {
  background-color: #74a147;
}
.backgroun4 {
  background-color: #7a985b;
}
.backgroun5 {
  background-color: #89987a;
}
</style>
